import React from 'react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  /** When true, links straight to checkout instead of scrolling to the offer section. */
  toCheckout?: boolean;
}
export function CTAButton({
  children,
  className = '',
  toCheckout = false
}: CTAButtonProps) {
  const classes = `
    inline-flex items-center justify-center w-full gap-2
    px-4 py-3
    font-heading font-extrabold text-sm sm:text-base uppercase tracking-wide text-center leading-tight
    rounded-lg
    bg-brand-green text-white
    hover:bg-brand-greenDark hover:shadow-xl
    focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-green/40
    transition-[background-color,box-shadow,transform,border-width] duration-150 ease-out
    border-b-4 border-brand-ink/40 active:border-b-0 active:translate-y-1
    shadow-lg shadow-brand-green/25
    ${className}
  `;
  if (toCheckout) {
    return <a href={CHECKOUT_URL} className={classes} data-id="element-37" data-mp="38mfs83yucy7p">
        {children}
      </a>;
  }
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <a href="#pricing" className={classes} onClick={handleClick} data-id="element-38" data-mp="1ibnwvbedyhxa">
      {children}
    </a>;
}